import React, { useContext, memo, useMemo, useState, useEffect } from 'react'
import uniqueId from 'lodash/uniqueId'
import orderBy from 'lodash/orderBy'
import Skeleton from '@material-ui/lab/Skeleton'

import { DeviceContext } from '../DeviceConnectionContainer'
import ChannelItem from './ChannelItem'
import { useGetMappingListQuery } from 'redux/rtk-query/devices'

const ChannelsSection = ({ devicesList = [] }) => {
  const [mappedChannel, setMappedChanel] = useState(null)

  const { state } = useContext(DeviceContext)

  const { meter_type, id: meterId } = state.selectedMeterValue?.value || {}

  const {
    data: meterToChannelList = [],
    isLoading,
    isFetching,
  } = useGetMappingListQuery(meterId, {
    skip: !meterId,
  })

  //   deviceConnected:
  // color: "#444C5A"
  // icon: "plug"
  // id: "18e0d38b-4954-4e79-aba1-b5d425cf9b87"
  // name: "BLANK"

  const channelList = useMemo(() => {
    const _list = Array(meter_type?.number_of_channels || 0)
      .fill(null)
      .map((_channel, index) => {
        const numberOfChannel = index + 1

        const mappingChanel = meterToChannelList?.find(
          (m) => m.channel === numberOfChannel
        )
        const device = devicesList?.find(
          (d) => d.id === mappingChanel?.device_id
        )

        return {
          channel: mappingChanel?.channel || numberOfChannel,
          device_id: mappingChanel?.device_id || null,
          id: mappingChanel?.id || uniqueId('not_device_'),
          meter_id: meterId,
          deviceConnected: device || null,
        }
      })
    return orderBy(
      _list,
      (listItem) => listItem?.deviceConnected?.name === 'BLANK',
      ['asc']
    )
  }, [devicesList, meterId, meterToChannelList, meter_type?.number_of_channels])

  useEffect(() => {
    if (mappedChannel) {
      setMappedChanel(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meterId])

  return (
    <div className="channel_section_container">
      {channelList.map((channel) => (
        <ChannelItem
          key={channel.id}
          {...channel}
          setMappedChanel={setMappedChanel}
          prevMappedChannel={mappedChannel}
          isFetchingList={isFetching}
        />
      ))}
      {(isLoading || isFetching) && !mappedChannel && (
        <div className="loader_container">
          <Skeleton className="loader" variant="rect" animation="wave" />
        </div>
      )}
    </div>
  )
}

export default memo(ChannelsSection)
